import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ClientSideStorageService } from 'src/app/services/client-side-storage.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-logs-events',
  templateUrl: './user-logs-events.component.html',
  styleUrl: './user-logs-events.component.scss'
})
export class UserLogsEventsComponent implements OnInit {
  placeholders = environment.placeholders as { [key: string]: string };
  userData: any
  deal_id: any
  deal: any;
  event: any;
  eventLogsSummary: any;
  dealimage: any;
  reportPlaceHolders:any

  events: any[] = []; // replace with your API/data input
  pageSize = 5;
  currentPage = 1;


  constructor(private dashboardService: DashboardService, private router: Router, private clientStorage: ClientSideStorageService) {
    this.userData = JSON.parse(this.clientStorage.get("marketplaceData"));
    const navigation = this.router.getCurrentNavigation();
    this.deal = navigation?.extras?.state?.['deal'];
    this.event = navigation?.extras?.state?.['events'];
    this.deal_id = this.deal.product_id
    this.dealimage = environment.assetsUrl + '/assets/' + this.deal?.product_image
    this.reportPlaceHolders = this.placeholders['Reports_page']
  }

  ngOnInit() {
    this.getAllDealLogsEvents()
  }


  getAllDealLogsEvents() {
    debugger
    let payload = {
      dealId: this.deal_id,
      brandId: this.userData.marketplace_id,
      eventType: this.event.eventType
    }

    this.dashboardService.getAllDealEventsUserLogs(payload).subscribe((res: any) => {
      if (res && res?.body.data) {
        this.events = res?.body.data.content
      }
    });


  }






  get paginatedEvents() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.events.slice(start, start + this.pageSize);
  }

  get totalPages() {
    return Math.ceil(this.events.length / this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) this.currentPage++;
  }

  prevPage() {
    if (this.currentPage > 1) this.currentPage--;
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'P': return this.reportPlaceHolders['LBL_PENDING'];
      case 'A': return this.reportPlaceHolders['LBL_ACTIVE'];
      case 'I': return this.reportPlaceHolders['LBL_INACTIVE'];
      case 'D': return this.reportPlaceHolders['LBL_DRAFT'];
      case 'C': return this.reportPlaceHolders['LBL_COMPLETED'];
      case 'E': return this.reportPlaceHolders['LBL_EXPIRED'];
      default: return status;
    }
  }

  getStatusClass(status: string): any {
    switch (status) {
      case 'A': return 'active-chip';
      case 'P': return 'pending-chip';
      case 'S': return 'paused-chip'
      case 'E': return 'expired-chip';
      case 'IA': return 'inactive-chip';
      case 'D': return 'draft-chip';
      case 'U': return 'upcoming-chip';
      case 'R': return 'rejected-chip';
      case 'N': return 'new-chip';
      case 'C': return 'completed-chip';
      default: return '';
    }
  }


  exportToPDF() {
    const doc = new jsPDF();
    const reportDate = this.getFormattedDateTime();

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = 'assets/images/expenses.png'; //environment.assetsUrl + '/assets/' + this.userData?.marketplace_image // Change path as needed

    img.onload = () => {
      // Convert image to Base64 and add to PDF
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);

      const imgData = canvas.toDataURL("image/png");

      doc.addImage(imgData, 'PNG', 10, 20, 40, 30);
      // Add header info
      doc.setFontSize(14);
      doc.text('Event logs detail for deals - Report', 55, 15);
      doc.setFontSize(10);
      doc.text(`Deal ID: ${this.deal.uuid}`, 55, 25);
      doc.text(`Deal name: ${this.deal.product_name}`, 55, 32);
      const descriptionText = `Description: ${this.deal.product_description}`;
      const wrappedDescription = doc.splitTextToSize(descriptionText, 150); // max width for wrapping
      
      doc.text(wrappedDescription, 55, 39); // render wrapped lines
      const nextY = 39 + (wrappedDescription.length * 5); // adjust spacing for next section
      
      doc.text(`Created on: ${this.deal.created_date}`, 55, nextY);
      doc.text(`Reported on: ${reportDate}`, 55, 55);
      
      // doc.setLineWidth(0.5); 
      // doc.line(10, nextY + 5, 200, nextY + 5);

      doc.setLineWidth(0.5); // Set line thickness
      doc.line(10, 60, 200, 60);
      // Prepare table body
      const body = this.events.map(event => [
        event.eventType,
        // event.userId,
        event.udi ? '****' + event.udi.slice(-4) : '-',
        event.age,
        event.dob,
        event.gender,
        new Date(event.eventDate).toLocaleString(),
        event.cost
      ]);

      // Create table
      autoTable(doc, {
        head: [['Event Type', 'UDI', 'Age', 'DOB', 'Gender', 'Event Date', 'Cost($)']],
        body,
        startY: 65
      });

      // Save the PDF
      doc.save('deal-event-report.pdf');
    }
  }

  getFormattedDateTime(): string {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  goBack() {
    this.router.navigate(['/eventreport']);
  }


}
